import React from 'react'
import Layout from '../../components/layout/Layout'
import Admin from '../../components/auth/Admin'

const AdminDashbored=() =>{
  return (
    <Layout>
      <Admin>
    <div>dashbored</div>
    </Admin>
    </Layout>
  )
}

export default AdminDashbored